module.exports = [
  // menu items
  {
    url: '/sourcing-wf/commitment-management/commitment-creation-edit',
    file (resolve) { require(['./CommitmentCreationEditPage.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/commitment-management/commitment',
    file (resolve) { require(['./Commitment.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/commitment-management/utilization',
    file (resolve) { require(['./Utilization.vue'], resolve) }
  },
  {
    url: '/sourcing-wf/commitment-management/utilization-creation-edit',
    file (resolve) { require(['./UtilizationCreationEditPage.vue'], resolve) }
  }
]



// WEBPACK FOOTER //
// ./src/components/commitmentmanagement/routes.js